import React from "react";
import "./common.css";
import { Icon, Button } from "antd";

const PayPlanCard = props => {
  return (
    <div className="plan-container">
      <div className="plan-card" style={{ backgroundColor: props.bgc }}>
        <p className="plan-title">{props.title}</p>
        <span className="plan-price">
          {props.price}/<span className="plan-mth">mth</span>
        </span>
        <p className="plan-detail">{props.detail}</p>
        {(props.state.checked && props.state.plan === props.title) ||
        (props.subscription[0] &&
          props.subscription[0].status === "active" &&
          props.subscription[0].plan_name === props.title) ? (
          <Icon
            style={{ marginTop: 20, fontSize: 50, color: "white" }}
            type="check"
          />
        ) : (
          <Icon
            style={{
              marginTop: 20,
              fontSize: 50,
              color: "white"
            }}
            type="mail"
          />
        )}

        {props.subscription[0] &&
        props.subscription[0].status === "active" &&
        props.subscription[0].plan_name === props.title ? (
          <Button
            disabled={
              (props.state.checked && props.state.plan === props.title) ||
              (props.subscription[0] &&
                props.subscription[0].status === "active" &&
                props.subscription[0].plan_name === props.title)
            }
            type="link"
            className="plan-button"
          >
            Subscription
          </Button>
        ) : (
          <Button
            disabled={
              (props.state.checked && props.state.plan === props.title) ||
              (props.subscription[0] &&
                props.subscription[0].status === "active" &&
                props.subscription[0].plan_name === props.title)
            }
            onClick={
              props.subscription[0] && props.subscription[0].status === "active"
                ? props.onChangePlan
                : props.onClickPlan
            }
            type="link"
            className="plan-button"
          >
            Start Plan
          </Button>
        )}
      </div>
    </div>
  );
};

export default PayPlanCard;
